import { render, staticRenderFns } from "./StrTable.vue?vue&type=template&id=c1453ce2&"
import script from "./StrTable.vue?vue&type=script&lang=js&"
export * from "./StrTable.vue?vue&type=script&lang=js&"
import style0 from "./StrTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports